module.exports = {
    isOpen: 'is-open',
    isVisible: 'is-visible',
    isPlaying: 'is-playing',
    hasToolTip: 'has-tooltip',
    hasDropdown: 'has-dropdown',
};